module.exports = __webpack_public_path__ + "images/add-quantityb220250c4e20ca03d3c00c5d78dc9415.svg";